
const {useState,useEffect} = wp.element;
const apiFetch=wp.apiFetch;
const {addQueryArgs}=wp.url;
export default function Railway() {

    const railways=[
        "railway_company",
        "railway_line",
        "railway_station",
    ];
    let railway_company=null;
    let railway_line=null;
    let railway_station=null;

    const user_railway = typeof window !== 'undefined' && window.user_railway ? window.user_railway : {
        railway_company:null,
        railway_line: null,
        railway_station: null,
    };
    if(user_railway.railway_company && user_railway.railway_line && user_railway.railway_station){
        railway_company=user_railway.railway_company;
        railway_line=user_railway.railway_line;
       railway_station=user_railway.railway_station;
    }

    const baseApiUrl="/railway/v2/railway_point/"
    const [company,setCompany] = useState([]);
    const [line,setLine] = useState([]);
    const [station,setStation] = useState([]);

    if(railway_company && railway_line && railway_station){
       useEffect(() => {
            getRailWayCurrentData(railway_company,"company");
            getRailWayCurrentData(railway_line,"line");
            getRailWayCurrentData(railway_station,"station");


       },[]);


    }else{
        useEffect(() =>{

            apiFetch({
                path: '/railway/v2/railway_point/',

            }).then((data) => {
                setCompany(data);
            });



        },[]);


    }
    function getRailWayCurrentData(id,name){
        const params = {
            current_id: encodeURIComponent(id),
            name: encodeURIComponent(name)
        };
        const apiUrlWithParams = addQueryArgs(baseApiUrl, params);

        apiFetch({path:apiUrlWithParams})
            .then((data) => {
                if(name==="company"){
                    setCompany(data);

                }
                if(name==="line"){
                    setLine(data);

                }
                if(name==="station"){
                    setStation(data);
                }


            })
            .catch((err) => {

                console.error(err);
            });

    }
    function getRailWayData(id,name){
        const params = {
            id: encodeURIComponent(id),
            name: encodeURIComponent(name)
        };
        const apiUrlWithParams = addQueryArgs(baseApiUrl, params);
        apiFetch({path:apiUrlWithParams})
            .then((data) => {
                if(name==="company"){
                    setCompany(data);
                }
                if(name==="line"){
                    setLine(data);

                }
                if(name==="station"){
                    setStation(data);
                }


            })
            .catch((err) => {

                console.error(err);
            });

    }


    const handleCompany = (e) => {
 console.log(e.target.value);
            getRailWayData(e.target.value, "line");

    }
    const handleLine = (e) => {

            getRailWayData(e.target.value, "station");

    };
    return(

        <>
            <label htmlFor="">
            <span>
                利用鉄道名
            </span>
                <select name="railway_company" id="" onChange={handleCompany} required>
                    <option value="">選択してください</option>
                    {company && company.map((item)=>{
                       let selected = (railway_company && railway_company==item.company_id) ? true: false;
                        return <option value={item.company_id} selected={selected}>{item.name}</option>
                    })}
                </select>
            </label>
            <label htmlFor="">
            <span>
                利用沿線名
            </span>
                <select name="railway_line" id="" onChange={handleLine} required>
                    <option value="">選択してください</option>
                    {line && line.map((item)=>{
                        let selected = (railway_line && railway_line==item.line_id) ? true: false;
                        return <option value={item.line_id} selected={selected}>{item.name}</option>
                    })}
                </select>
            </label>
            <label htmlFor="">
            <span>
                最寄駅名
            </span>
                <select name="railway_station" id="" required>
                    <option value="">選択してください</option>
                    {station && station.map((item)=>{
                        let selected = (railway_station && railway_station==item.station_id) ? true: false;

                        return <option value={item.station_id} selected={selected}>{item.name}</option>
                    })}
                </select>
            </label>
        </>
    )

}